import type * as React from "react";
import type { SVGProps } from "react";

interface SvgStarProps extends SVGProps<SVGSVGElement> {
  fill?: string;
}

const SvgStar: React.FC<SvgStarProps> = ({
  fill = "currentColor",
  width = 14,
  height = 14,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 19.481 19.481"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="m10.201.758 2.478 5.865 6.344.545a.5.5 0 0 1 .285.876l-4.812 4.169 1.442 6.202a.5.5 0 0 1-.745.541l-5.452-3.288-5.452 3.288a.5.5 0 0 1-.745-.541l1.442-6.202-4.813-4.17a.5.5 0 0 1 .285-.876l6.344-.545L9.28.758a.5.5 0 0 1 .921 0"
    />
  </svg>
);

export default SvgStar;
